module.exports = __webpack_public_path__ + "static/img/game1_bg.a77cd264.png";